import React, { useState } from 'react';
import { Dropdown, DropdownMenu, DropdownToggle, Container } from 'react-bootstrap';
import { MdKeyboardArrowDown } from "react-icons/md";
import Images from '../Images';
import { Link } from 'react-router-dom';

function Subheader() {

    const [showDropdown1, setShowDropdown1] = useState(false);
    const [showDropdown2, setShowDropdown2] = useState(false);
    const [showDropdown3, setShowDropdown3] = useState(false);
    const [showDropdown4, setShowDropdown4] = useState(false);
    const [showDropdown5, setShowDropdown5] = useState(false);
    const [showDropdown6, setShowDropdown6] = useState(false);
    const [showDropdown7, setShowDropdown7] = useState(false);
    const [showDropdown8, setShowDropdown8] = useState(false);

    const [showDropdown9, setShowDropdown9] = useState(false);

    const [showSubDropdown, setShowSubDropdown] = useState(false);
    const [showSubDropdown1, setShowSubDropdown1] = useState(false);
    const [showSubDropdown2, setShowSubDropdown2] = useState(false);

    return (

        <div className='subheader'>
            <Container>
                <div className='d-block d-xl-flex align-items-center flexwrap'>
                
                
                <Dropdown className='edaface_drop' onMouseLeave={() => setShowDropdown9(false)}
                    onMouseOver={() => setShowDropdown9(true)}>
                    <DropdownToggle className='ps-0'>Verification Asset Center(VAC) <MdKeyboardArrowDown className='arrowsvg' /></DropdownToggle>
                    <DropdownMenu className='py-2 px-3' show={showDropdown9}>
                        <Link  to="/"><img src={Images.square} className='me-2 navicon' alt="icons" /> Check Scams</Link>
                      
                        <Dropdown
      className="sub-dropdown mb-2 mb-xl-0"
      onMouseLeave={() => setShowSubDropdown(false)}
      onMouseOver={() => setShowSubDropdown(true)}
    >
      <DropdownToggle as="div" className="dropdown-item subdropitem d-flex align-items-center px-0 mb-0 mb-xl-3">
        <img src={Images.doc} className="me-2 navicon" alt="icons" /> List your projects
      </DropdownToggle>
      <DropdownMenu show={showSubDropdown} className="py-2 px-3 subdropmenu">
        <Link to="#"><img src={Images.square} className='me-2 navicon' alt="icons" />List Presale</Link>
        <Link to="/listcointoken"><img src={Images.square} className='me-2 navicon' alt="icons" />List Crypto</Link>
        <Link to="/listexchange"><img src={Images.square} className='me-2 navicon' alt="icons" />List Exchange</Link>
        <Link to="/myrequest"><img src={Images.square} className='me-2 navicon' alt="icons" />List your Form</Link>
      </DropdownMenu>
    </Dropdown>
                  
                    </DropdownMenu>
                </Dropdown>
                <Dropdown className='edaface_drop' onMouseLeave={() => setShowDropdown1(false)}
                    onMouseOver={() => setShowDropdown1(true)}>
                    <DropdownToggle className='ps-0'>Cryptocurrencies <MdKeyboardArrowDown className='arrowsvg' /></DropdownToggle>
                    <DropdownMenu className='py-2 px-3' show={showDropdown1}>
                        <Link  to="/"><img src={Images.doc} className='me-2 navicon' alt="icons" /> Coin Ranking</Link>
                        <Link  to="/"><img src={Images.square} className='me-2 navicon' alt="icons" /> ETFs</Link>
                    </DropdownMenu>
                </Dropdown>
                <Dropdown className='edaface_drop' onMouseLeave={() => setShowDropdown3(false)}
                    onMouseOver={() => setShowDropdown3(true)}>
                    <DropdownToggle >Exchanges <MdKeyboardArrowDown className='arrowsvg' /></DropdownToggle>
                    <DropdownMenu className='py-2 px-3' show={showDropdown3}>
                    <Dropdown
      className="sub-dropdown mb-2 mb-xl-0"
      onMouseLeave={() => setShowSubDropdown1(false)}
      onMouseOver={() => setShowSubDropdown1(true)}
    >
      <DropdownToggle as="div" className="dropdown-item subdropitem d-flex align-items-center px-0 mb-0 mb-xl-3">
        <img src={Images.doc} className="me-2 navicon" alt="icons" /> CEX
      </DropdownToggle>
      <DropdownMenu show={showSubDropdown1} className="py-2 px-3 subdropmenu">
        <Link to="#"><img src={Images.square} className='me-2 navicon' alt="icons" />Spot</Link>
        <Link to="#"><img src={Images.square} className='me-2 navicon' alt="icons" />Derivative</Link>
      </DropdownMenu>
    </Dropdown>
                    <Dropdown
      className="sub-dropdown mb-2 mb-xl-0"
      onMouseLeave={() => setShowSubDropdown2(false)}
      onMouseOver={() => setShowSubDropdown2(true)}
    >
      <DropdownToggle as="div" className="dropdown-item subdropitem d-flex align-items-center px-0 mb-0 mb-xl-3">
        <img src={Images.doc} className="me-2 navicon" alt="icons" /> DEX
      </DropdownToggle>
      <DropdownMenu show={showSubDropdown2} className="py-2 px-3 subdropmenu">
        <Link to="#"><img src={Images.square} className='me-2 navicon' alt="icons" />Spot</Link>
        <Link to="#"><img src={Images.square} className='me-2 navicon' alt="icons" />Derivative</Link>
      </DropdownMenu>
    </Dropdown>
                
                    </DropdownMenu>
                </Dropdown>

                <Dropdown className='edaface_drop' onMouseLeave={() => setShowDropdown4(false)}
                    onMouseOver={() => setShowDropdown4(true)}>
                    <DropdownToggle >Trending <MdKeyboardArrowDown className='arrowsvg' /></DropdownToggle>
                    <DropdownMenu className='py-2 px-3' show={showDropdown4}>
                        <Link  to="/"><img src={Images.square} className='me-2 navicon' alt="icons" /> Top Gainer</Link>
                        <Link  to="/"><img src={Images.square} className='me-2 navicon' alt="icons" /> Top Looser</Link>
                        <Link  to="/"><img src={Images.square} className='me-2 navicon' alt="icons" /> Popular Crypto</Link>
                        <Link  to="/"><img src={Images.square} className='me-2 navicon' alt="icons" /> New Arrivals</Link>
                    </DropdownMenu>
                </Dropdown>
                <Dropdown className='edaface_drop' onMouseLeave={() => setShowDropdown5(false)}
                    onMouseOver={() => setShowDropdown5(true)}>
                    <DropdownToggle >Trade <MdKeyboardArrowDown className='arrowsvg' /></DropdownToggle>
                    <DropdownMenu className='py-2 px-3' show={showDropdown5}>
                        <Link  to="/"><img src={Images.doc} className='me-2 navicon' alt="icons" /> EdaFace Dex</Link>
                        <Link  to="/"><img src={Images.square} className='me-2 navicon' alt="icons" /> P2P Market</Link>
                        <Link  to="/"><img src={Images.square} className='me-2 navicon' alt="icons" /> Launchpad</Link>
                    </DropdownMenu>
                </Dropdown>
                {/* <Dropdown className='edaface_drop' onMouseLeave={() => setShowDropdown6(false)}
                    onMouseOver={() => setShowDropdown6(true)}>
                    <DropdownToggle >List Your Project <MdKeyboardArrowDown className='arrowsvg' /></DropdownToggle>
                    <DropdownMenu className='py-2 px-3' show={showDropdown6}>
                        <Link  to="/"><img src={Images.doc} className='me-2 navicon' alt="icons" /> List Presales</Link>
                        <Link  to="/"><img src={Images.square} className='me-2 navicon' alt="icons" /> List Crypto</Link>
                        <Link  to="/"><img src={Images.square} className='me-2 navicon' alt="icons" /> VAC</Link>
                    </DropdownMenu>
                </Dropdown> */}
                <Dropdown className='edaface_drop' onMouseLeave={() => setShowDropdown7(false)}
                    onMouseOver={() => setShowDropdown7(true)}>
             <DropdownToggle >Profile <MdKeyboardArrowDown className='arrowsvg' /></DropdownToggle>
             <DropdownMenu className='py-2 px-3' show={showDropdown7}>
            
                    <>
             <Link  to="/"><img src={Images.doc} className='me-2 navicon' alt="icons" /> Register</Link>
             <Link  to="/"><img src={Images.doc} className='me-2 navicon' alt="icons" /> Login</Link> 
             </>

           
                </DropdownMenu>
                </Dropdown>


                <Dropdown className='edaface_drop' onMouseLeave={() => setShowDropdown8(false)}
                    onMouseOver={() => setShowDropdown8(true)}>
             <DropdownToggle >Resources <MdKeyboardArrowDown className='arrowsvg' /></DropdownToggle>
             <DropdownMenu className='py-2 px-3' show={showDropdown8}>
        
                </DropdownMenu>
                </Dropdown>



                {/* <Dropdown className='edaface_drop' onMouseLeave={() => setShowDropdown7(false)}
                    onMouseOver={() => setShowDropdown7(true)}>
                    <DropdownToggle >Profile <MdKeyboardArrowDown className='arrowsvg' /></DropdownToggle>
                    <DropdownMenu className='py-2 px-3' show={showDropdown7}>
                        <Link  to="/"><img src={Images.doc} className='me-2 navicon' alt="icons" /> Coin Ranking</Link>
                        <Link  to="/"><img src={Images.square} className='me-2 navicon' alt="icons" /> Check Scam VAC</Link>
                        <Link  to="/"><img src={Images.square} className='me-2 navicon' alt="icons" /> Crypto ETFs</Link>
                    </DropdownMenu>
                </Dropdown> */}
                {/* <Dropdown className='edaface_drop' onMouseLeave={() => setShowDropdown8(false)}
                    onMouseOver={() => setShowDropdown8(true)}>
                    <DropdownToggle >Resources <MdKeyboardArrowDown className='arrowsvg' /></DropdownToggle>
                    <DropdownMenu className='py-2 px-3' show={showDropdown8}>
                        <Link  to="/"><img src={Images.doc} className='me-2 navicon' alt="icons" /> Coin Ranking</Link>
                        <Link  to="/"><img src={Images.square} className='me-2 navicon' alt="icons" /> Check Scam VAC</Link>
                        <Link  to="/"><img src={Images.square} className='me-2 navicon' alt="icons" /> Crypto ETFs</Link>
                    </DropdownMenu>
                </Dropdown> */}
                </div>
            </Container>
        </div>
    )
}

export default Subheader;